import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoSlash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 17,
	viewBox: "0 0 23 17",
	fill: "black",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.07865 3.49286C2.07865 3.49285 2.07866 3.49283 2.07866 3.49282L1.1456 2.55975C0.761512 2.16873 0.763654 1.54039 1.15202 1.15202C1.54255 0.7615 2.17571 0.7615 2.56624 1.15202L16.6469 15.2327C17.0374 15.6232 17.0374 16.2564 16.6469 16.6469C16.2585 17.0353 15.6301 17.0374 15.2391 16.6533L14.3407 15.7549C14.3407 15.7549 14.3407 15.7549 14.3407 15.7549L2.07865 3.49286ZM2.00002 4.82844V14.1669C2.00002 15.0874 2.74621 15.8335 3.66668 15.8335H13.0051L2.00002 4.82844ZM15.5 12.6716V4.00022C15.5 3.07974 14.7538 2.33355 13.8334 2.33355H5.16198L15.5 12.6716ZM17.3661 6.59292C17.1416 6.70632 17 6.93645 17 7.188V10.8121C17 11.0637 17.1416 11.2938 17.3661 11.4072L21.5328 13.5116C21.9762 13.7355 22.5 13.4132 22.5 12.9165V5.08362C22.5 4.58686 21.9762 4.26459 21.5328 4.48854L17.3661 6.59292Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgVideoSlash);
export { ForwardRef as ReactComponent };
